// 0: Female, 1: Male
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import maleBlue from 'src/assets/male_blue.svg';
import maleWhite from 'src/assets/male_white.svg';
import femaleBlue from 'src/assets/female_blue.svg';
import femaleWhite from 'src/assets/female_white.svg';
import './style.scoped.css';

const GENDER_LIST = [
  {
    id: 'FEMALE',
    text: 'female',
    iconActive: femaleWhite,
    iconInactive: femaleBlue,
  },
  {
    id: 'MALE',
    text: 'male',
    iconActive: maleWhite,
    iconInactive: maleBlue,
  },
];

const GenderItem = (props) => {
  const {
    id,
    text,
    iconActive,
    iconInactive,
    isActive,
    extraClassName,
    onClick,
  } = props;

  const _handleClick = useCallback(() => {
    onClick(id);
  }, [id, onClick]);

  if (isActive) {
    return (
      <div className={`itemActive ${extraClassName}`} onClick={_handleClick}>
        <div className="flex-1 inputValueOnPrimary">{text}</div>
        <div>
          <img src={iconActive} className="icon" />
        </div>
      </div>
    );
  }
  return (
    <div className={`itemInactive ${extraClassName}`} onClick={_handleClick}>
      <div className="flex-1 inputValue">{text}</div>
      <div>
        <img src={iconInactive} className="icon" />
      </div>
    </div>
  );
};

interface GenderSelectorProps {
  value: 'MALE' | 'FEMALE' | null;
  onChange: (g: 'MALE' | 'FEMALE' | null) => void;
  isRequired?: boolean;
  helperText?: string;
  error?: boolean;
}

const GenderSelector = (props: GenderSelectorProps) => {
  const {
    value,
    onChange,
    isRequired = false,
    helperText,
    error = false,
  } = props;

  const { t } = useTranslation();

  const _handleClick = useCallback(
    (id) => {
      if (id != value) {
        onChange(id);
      } else {
        onChange(null);
      }
    },
    [value, onChange]
  );

  return (
    <div>
      <div className="labelText mb-2">
        {t('gender')}
        {isRequired ? <label className="bodyText text-error"> *</label> : ''}
      </div>

      <div className="flex flex-row">
        {GENDER_LIST.map((item, index) => {
          const isActive = item.id == value;
          return (
            <GenderItem
              {...item}
              text={t(item.text)}
              extraClassName={index < GENDER_LIST.length - 1 ? 'mr-4' : ''}
              isActive={isActive}
              onClick={_handleClick}
              key={item.id}
            />
          );
        })}
      </div>
      {!!helperText && (
        <div
          className={`${
            error ? 'text-error' : 'text-labelHelper'
          } text-xs mt-2 font-normal`}
        >
          {helperText}
        </div>
      )}
    </div>
  );
};

export default GenderSelector;
